
/**
 * Custom component for Back Bar items.
 *
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 1.0.2
 * @copyright  Copyright (C) 2023-2025, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 *
 *    2023-12-19 (1.0.0) (jhoward)
 *      - <WVSteakHouseFoodItem> copied to <back-bar-default-item>.
 *
 *    2024-07-19 (1.0.1) (jhoward)
 *      - Rename .visual_menu--tag CSS rules to .menu--tag in <back-bar-default-item>.
 *
 *    2025-04-08 (1.0.2) (jhoward)
 *      - Remove "visual_" prefix from class names in <back-bar-default-item>.
 */

import {defineComponent, PropType} from "vue";
import {MenuItem} from "../defs";
import DefaultItem from "./defaultItem.vue";

export default defineComponent({
  name: 'BackBarDefaultItem',
  components: {
    DefaultItem
  },
  props: {
    item: {
      type: Object as PropType<MenuItem>,
      required: true
    },
  },
  computed: {
    itemFormatted(): MenuItem {
      const output = {...this.item};
      output.mi_title = output.mi_title.replace(/\*/g, '<span class="menu--item_title_asterisk">*</span>');
      return output;
    }
  }
})
